import SiteLayout from '../../components/common/SiteLayout';
import usePageMeta from '../../components/common/usePageMeta';

// The page bodies are plain HTML; these rules reproduce the live WordPress theme's computed styles.
const baseClasses = [
    "font-['Inter_Legal',sans-serif] text-[18px] font-medium leading-[1.5] break-words",
    '[&_a]:underline [&_a]:transition-all [&_a]:duration-300',
    "[&_h4]:mb-[1.6875rem] [&_h4]:font-['Mango_Grotesque',Arial,sans-serif] [&_h4]:text-[36px] [&_h4]:font-normal [&_h4]:uppercase [&_h4]:leading-[1.1] [&_h4]:tracking-[0.4px] max-md:[&_h4]:leading-[0.9]",
    '[&_h5]:mb-[1.6875rem] [&_h5]:text-[20px] [&_h5]:font-bold [&_h5]:uppercase',
    '[&_ol]:ml-[1.75rem] [&_ul]:ml-[1.75rem] [&_ol]:list-decimal [&_ul]:list-disc [&_ul>li]:marker:text-[0.7em]',
    '[&_figure]:overflow-x-auto [&_table]:mb-[24px] [&_table]:w-full [&_table]:table-fixed [&_table]:border [&_table]:border-[#ccc] [&_table]:leading-[24px]',
    '[&_thead]:border-b-[3px] [&_thead]:border-white [&_thead]:font-bold [&_th]:border [&_td]:border [&_th]:border-white [&_td]:border-white [&_th]:p-[0.5em] [&_td]:p-[0.5em] [&_th]:text-left',
    '[&_#consent-settings-btn]:flex [&_#consent-settings-btn]:cursor-pointer [&_#consent-settings-btn]:rounded-[20px] [&_#consent-settings-btn]:border [&_#consent-settings-btn]:border-[#00E387] [&_#consent-settings-btn]:bg-[#468254] [&_#consent-settings-btn]:px-[2em] [&_#consent-settings-btn]:py-[0.8em]',
    '[&_#consent-settings-btn]:text-[0.8em] [&_#consent-settings-btn]:font-semibold [&_#consent-settings-btn]:leading-[1.2] [&_#consent-settings-btn]:tracking-[-0.2px] [&_#consent-settings-btn]:text-white [&_#consent-settings-btn]:transition-all [&_#consent-settings-btn]:duration-100 [&_#consent-settings-btn:hover]:bg-[#2c6415]',
    '[&_[id]]:scroll-mt-[130px]',
].join(' ');

const themeSpacing = '[&_p]:mb-[1.6875rem] [&_ol]:mb-[1.6875rem] [&_ul]:mb-[1.6875rem] [&_figure]:mb-[1.6875rem] [&_a:hover]:text-[#00E387]';

const agreementSpacing = [
    '[&_p]:mb-[1.25em] [&_ol]:mb-[1.25em] [&_ol]:mt-[1em] [&_ul]:mb-[1.25em] [&_ul]:mt-[1em]',
    '[&_ol_ol]:mt-[0.75em] [&_ol_ul]:mt-[0.75em] [&_ul_ul]:mt-[0.75em]',
    '[&_li]:mb-[0.75em] [&>ol>li]:mb-[1.75em] [&_ol>li>ol>li]:mb-[0.6em] [&_hr]:my-[2.5em]',
    '[&_a]:text-[#00E387] [&_a:hover]:opacity-[0.85]',
].join(' ');

const renderLine = (line) => {
    const [before, highlight, after] = line.split(/\[(.+)\]/);
    return <>{before}{highlight && <span className="text-[#00E387]">{highlight}</span>}{after}</>;
};

export default function LegalPage({ page }) {
    const [firstLine, secondLine] = page.heading.split('|');

    usePageMeta(page);

    return (
        <SiteLayout headerVariant="full" overlayHeader>
            <article className="mx-auto max-w-[1068px] px-[15px] pb-16 pt-[139px] text-white md:pb-24 md:pt-[282px] min-[1025px]:px-[40px]">
                <h1 className="mb-[53px] text-center font-['Mango_Grotesque'] text-[90px] font-extrabold uppercase leading-[0.8] md:mb-[130px] min-[861px]:text-[110px] min-[1141px]:text-[170px]">
                    {renderLine(firstLine)}
                    {secondLine && <><br />{renderLine(secondLine)}</>}
                </h1>
                <div
                    className={`${baseClasses} ${page.agreement ? agreementSpacing : themeSpacing}`}
                    dangerouslySetInnerHTML={{ __html: page.html }}
                />
            </article>
        </SiteLayout>
    );
}
